import { FC } from "react";
import { Button, ButtonProps, Form, Grid } from "antd";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { SearchIcon } from "src/assets/Icons";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";

const SearchSubmit: FC<ButtonProps> = ({ className, ...props }) => {
  const { t } = useTranslation();
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  return (
    <Form.Item className="m-0! w-full items-center justify-center md:flex md:w-min">
      <Button
        htmlType="submit"
        className={cn("bg-background-primary! text-icon-inverted! border-none! font-semibold! w-full! h-full! max-h-14 p-3! md:w-min!", className)}
        classNames={{
          icon: "flex! items-center! justify-center! w-full! h-full!",
        }}
        icon={isLargeScreen && <SearchIcon className="h-5 w-5" strokeWidth={1.5} />}
        {...props}
      >
        {!isLargeScreen && t("Hotels.search.searchHotels")}
      </Button>
    </Form.Item>
  );
};

export default SearchSubmit;
